import { IQuestion } from '@sdk/contracts';
import { create } from 'zustand';

interface IStore {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  selectedQuestions: IQuestion[];
  setSelectedQuestions: (selectedQuestions: IQuestion[]) => void;
}

export const useAddFromQuestionBankModal = create<IStore>(set => ({
  isOpen: false,
  setIsOpen: isOpen => set({ isOpen }),
  selectedQuestions: [],
  setSelectedQuestions: selectedQuestions => set({ selectedQuestions })
}));
